

























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import CustomerDetails from '@/components/Net20/CustomerDetails.vue';
import { DropDownItem } from "@/services/DropDownItem";
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";
import { i18n } from '@/i18n/i18n-setup';
import {getDropDownStepList, STEP_ENUM} from '@/entity/Net20/ContractStep'
import { SOURCE, SyncNet20Dropdowns } from '@/services/Net20DropDowns';
import DownloadFileBackground from '../Utilities/DownloadFileBackground.vue';
import DocumentAttachment from './DocumentAttachment.vue';
import { PROCESS_TYPE_ENUM } from '@/services/Enums';
import ContractStepBack from "./modules/ContractStepBack.vue";
import { Contract } from '@/entity/Net20/Contract';
import { ClaimEnum } from '@/services/ClaimEnum';
import SalesmanSelection from './modules/SalesmanSelection.vue';
import { CustomerGarageFilterModel } from '@/entity/Net20/CustomerGarageFilterModel';
import { MassiveCustomerUpdate } from '@/entity/Net20/MassiveCustomerUpdate';

@Component({
    components: {
        SearchFilter,
        CustomerDetails,
        LeftClickOptionMenu,
        DocumentAttachment,
        DownloadFileBackground,
        ContractStepBack,
        SalesmanSelection
    },
})
export default class CustomersSearch extends Vue { 
    idCustomerDetail: any = null;
    numericIdSelected: number = null;
    selectedContractId: number = null;
    selectedContract: Contract = null;
    selectCustomerCountry: string = null;
    adminUtilsReady: boolean = false;
    contractStepBackVisibility: boolean = false;

    isSalesman: boolean = false;
    showLoading: boolean = false;
    ready: boolean = false;
    downloadReportInProgress: boolean = false;
    downloadReportBtnLabel: string = '';
    customerDetailEditMode: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    filterSelected: boolean = false;
    advNumericId: string = null;
    advCustomerId: string = null;
    advWorkshopName: string = null;
    advVatNumber: string = null;
    advIdSalesman: string = null;
    advTypeOfProposal: string = null;
    advIdStepContract: string = null;
    advContractYear: string = null;
    advCustomerCountry: string = null;
    advDistributor: string = null;
    advContractExpired: boolean = null;

    dropDownSalesman: any = new Array();
    dropDownTypesOfProposal: any = new Array();
    dropDownCountries: any = new Array();
    dropDownSteps: any = new Array(); 
    dropDownDistributor: any = new Array();
    workShopName: string = '';
    workShop: any = null;
    workShopHeader: string = '';
    startValidation: boolean = false;

    selectedCustomersIds: Array<string> = new Array<string>();
    selectedCustomer: string = null;
    unSelectedCustomersId: Array<string> = new Array<string>();
    allSelected: boolean = false;
    allSelectedBackend: boolean = false;
    totalCustomerInvolved: number = 0;
    massiveCustomerUpdate: MassiveCustomerUpdate = new MassiveCustomerUpdate();

    searchFilters: any = null;
    downloadUrl: string = "/api/net20/DownloadAllRecords"
    processDescription: string = "NET20 - Downloading All Record Report"
    processType: PROCESS_TYPE_ENUM = PROCESS_TYPE_ENUM.downloadFiles;
    activeFilterFromWidget: boolean = false;
    isCollapseVisible: boolean = false;

    //pacchetto per menu tasto destro su dettaglio entita'
    leftClickOptionMenuUrl: string = "/net20s/";
    leftClickOptionMenuUrlArgument: string = "numericId";
    handleClick (event, item) {
        (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
    }

    created() {
        //imposto da qui il prop da inviare al componente "SearchFilter", perche' al mounted il componente e' gia' renderizzato
        if (this.$route.path.search("/contractExpired=") > -1){
            this.activeFilterFromWidget = true;
        } 
    }

    async mounted() {
        this.downloadReportBtnLabel = i18n.t('NET20.DOWNLOAD_ALL_RECORDS') as string;
        this.dropDownCountries = await this.getDropdownCountries();
        this.dropDownSteps = getDropDownStepList();
        this.dropDownSalesman = await this.getDropdownSalesman();
        this.setIsSalesman();
        
        //Recupero la lista includendo i valori dismessi per la ricerca
        this.dropDownTypesOfProposal = await General.GetDropdownList(SOURCE.TYPE_OF_PROPOSAL);      
        this.dropDownDistributor = await General.GetDropdownList(SOURCE.DISTRIBUTOR);

        await SyncNet20Dropdowns();
        
        if (this.$route.path.search("/contractExpired=") > -1){
            this.isCollapseVisible = true;
            let contractExpired = this.$route.params.id.replace('contractExpired=','');                
            this.advContractExpired =  contractExpired === "1" ? true : false;
            this.searchFilterSearchEvent(null);   
            this.ready = true;
            return;
        }

        this.ready = true;

        if (this.$route.params.id) {
            let app: any = this;
            let customerNumericId: string = this.$route.params.id;
            let promise = this.getCustomerIdByNumericId(customerNumericId);   
            promise.then(function (val) {
                let customer: any = {
                    numericId: customerNumericId,
                    id: val
                };
                app.openCustomer(customer, true);
            });
        }

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId=='customer-details-modal'){
                this.$router.push({name:'Customer'});  
            }
            
        })
    }
    
    IsValidateField(fieldValid: boolean): boolean {
        if (this.startValidation && !fieldValid) {
            return false;
        }
        return true;
    }

    getResultValue(result) {
        return result.workshopName;  
    }
    
    workShopSelected(workShop: any ){
        if(workShop != null){
            this.workShop = workShop;
            this.workShopHeader = this.workShop.workshopName;
            this.advWorkshopName = this.workShop.workshopName;
        }

    }

    resetFieldAutocomplete(){
        this.startValidation = false;
        this.workShopHeader = '';
        (this.$refs.autocompletefield as any).reset();
    }

    isAdminUtilsVisible() {
        let check = false;
        let isAdminNet20 = General.CheckAuthorization(ClaimEnum.CanAdminNet20);

        if(isAdminNet20 && this.adminUtilsReady) {
            check = true;
        }
        return check;
    }

    isAdminUtilsVisibleTable(){
        let isAdminNet20 = General.CheckAuthorization(ClaimEnum.CanAdminNet20);
        
        if(isAdminNet20 && ( this.selectedCustomersIds.length > 0)){
            return true;
        }else{
            return false;
        }
    }

    isAdmin() {
        return General.CheckAuthorization(ClaimEnum.CanAdminNet20);
    }

    openCustomerFromRouteParams() {          
        if (this.$route.params.id) {
            let app: any = this;
            let customerNumericId: string = this.$route.params.id;
            let promise = this.getCustomerIdByNumericId(customerNumericId);   
            promise.then(function (val) {
                let customer: any = {
                    numericId: customerNumericId,
                    id: val
                };
                app.openCustomer(customer, true);
            });
        }
    }

    setIsSalesman() {
        var username = this.$store.state.user.Username;
        if (this.$store.state.impersonatedBy != null)
            username = this.$store.state.userToImpersonate;

        var checkIndex = this.dropDownSalesman.findIndex(s => s.text.toLowerCase() === username.toLowerCase());
        if(checkIndex >= 0) {
            this.isSalesman = true;
        } else {
            this.isSalesman = false;
        }
    }

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    get CustomerDetailModalTitle(): string {
        if(this.numericIdSelected != null)
            return `${i18n.t('NET20.CUSTOMER') as string}: ${this.numericIdSelected}`;
        else
            return i18n.t('NET20.NEW_CUSTOMER') as string;
    }

    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    get AdvancedSearchFilled(): boolean {      
        return this.CheckAdvancedSearchFilled();
    }

    CheckAdvancedSearchFilled(): boolean {
        if (!this.CheckIsNullOrEmpty(this.advNumericId)) return true;     
        if (!this.CheckIsNullOrEmpty(this.advCustomerId)) return true;     
        if (!this.CheckIsNullOrEmpty(this.advWorkshopName)) return true;
        if (!this.CheckIsNullOrEmpty(this.advVatNumber)) return true;
        if (!this.CheckIsNullOrEmpty(this.advTypeOfProposal)) return true;
        if (!this.CheckIsNullOrEmpty(this.advIdStepContract)) return true;
        if (!this.CheckIsNullOrEmpty(this.advIdSalesman)) return true;
        if (!this.CheckIsNullOrEmpty(this.advContractYear)) return true;
        if (!this.CheckIsNullOrEmpty(this.advCustomerCountry)) return true;
        if (!this.CheckIsNullOrEmpty(this.advDistributor)) return true;
        if (!this.CheckIsNullOrEmpty(this.advContractExpired)) return true;
        return false;
    }

    CheckSearchFilled() {
        if(!this.CheckIsNullOrEmpty(this.freeText)) return true;
        if(this.CheckAdvancedSearchFilled()) return true;
        return false;     
    }

    resetFilters() {
        this.advNumericId = null;
        this.advCustomerId = null;
        this.advWorkshopName = null;
        this.advVatNumber = null;
        this.advTypeOfProposal = null;
        this.advIdStepContract = null;
        this.advIdSalesman = null;
        this.advContractYear = null;
        this.advCustomerCountry = null;
        this.advDistributor = null;
        this.advContractExpired = null;
        this.filterSelected = false;
        this.resetFieldAutocomplete();
    }

    async getAndOpenCustomer(numericId: string) {
        let app: any = this;
        let promise = this.getCustomerIdByNumericId(numericId);                
        promise.then(function (val) {
            let customer: any = {
                numericId: numericId,
                id: val
            };
            app.openCustomer(customer, false);
        });
    }

    async postAddingCustomer(numericId: string) {
        this.getAndOpenCustomer(numericId);
    }

    async postUpdatingCustomer(numericId: string) {
        this.getAndOpenCustomer(numericId);
    }

    afterContractStepBack() {
        this.$bvModal.hide('contractStepBackModal');
        this.$bvModal.hide('customer-details-modal');
        this.openCustomerFromRouteParams();
    }

    onSelectingContract(contractSelected, isRenewal) {
        if(this.idCustomerDetail != null)
            this.adminUtilsReady = true;

        this.selectedContract = contractSelected;

        if(isRenewal || this.selectedContract.idStep == STEP_ENUM.EVALUATION_FORM)
            this.contractStepBackVisibility = false;
        else
            this.contractStepBackVisibility = true;
    }

    onCustomerDetailExecutingAction() {
        this.adminUtilsReady = false;
    }

    async getDropdownCountries(): Promise<Array<any>> {
        try{
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/net20/GetCountriesForUser'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                response.data.forEach( element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropdownSalesman(): Promise<Array<any>> {
        try{
            let user: DropDownItem = new DropDownItem();
            let usersList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/net20/GetSalesmanForUser'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                response.data.forEach( element => {
                    user = new DropDownItem();
                    user.idDropDownItem = element.idUser;
                    user.itemText = element.username;

                    usersList.push(user);
                });
                return General.SetOptionsDropDown(usersList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    handleUnauthorizedUser() {
        this.close();

        let newPath = '/net20s/'
        if (this.$route.path !== newPath) 
            this.$router.push(newPath);

        General.showAlertDanger(i18n.t('GENERIC.MSG_UNAUTHORIZED_USER') as string,this);
    }

    async getCustomerIdByNumericId(numericId: string) {
        let idCustomer: string = null;

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/net20/GetCustomerIdByNumericId?numericId=' + numericId),
                responseType: 'json',
                withCredentials: true
            });
            idCustomer = response.data;
        } catch (error) {
            General.HandleError(error, this);
        }
        return idCustomer;
    }

    openCustomer(customer: any, forceOpen: boolean) {   
        this.adminUtilsReady = false;
        let newPath = '/net20s/' + customer.numericId;
        if (!forceOpen && this.$route.path !== newPath) 
            this.$router.push(newPath);

        this.selectedContractId = customer.lastContractId;
        this.selectCustomerCountry = customer.idCountry;
        this.customerDetailEditMode = true;
        this.idCustomerDetail = customer.id;
        this.numericIdSelected = customer.numericId;
        this.$bvModal.show('customer-details-modal');
    }

    createCustomer() {
        this.adminUtilsReady = false;
        this.customerDetailEditMode = false;
        this.idCustomerDetail = null;
        this.numericIdSelected = null;
        this.$bvModal.show('customer-details-modal');
    }

    close() {
        this.$bvModal.hide('customer-details-modal');
    }
    
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch;
        
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.downloadReportBtnLabel = i18n.t('NET20.DOWNLOAD_ALL_RECORDS') as string;
        this.resetFilters()
    }

    searchItems(start: boolean) {
        this.searchCustomersDo(start);
    }

    async searchCustomersDo(start: boolean) {
        this.showLoading = true;
        if (start == true){
            this.resetSearch();
            this.resetSelection();
        }
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/GetCustomerWithFilter'),
                data: {
                    FreeText: this.freeText,
                    CustomerId: this.advCustomerId,
                    NumericIdsList: this.advNumericId,
                    WorkshopName: this.advWorkshopName,
                    VatNumber: this.advVatNumber,
                    IdSalesman: this.advIdSalesman,
                    TypeOfProposal: this.advTypeOfProposal,
                    IdCountry: this.advCustomerCountry,
                    IdStepContract: this.advIdStepContract,
                    ContractYear: this.advContractYear,
                    IdDistributor: this.advDistributor,
                    ContractExpired: this.advContractExpired,
                    CurrentPage: this.page,
                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;

            if(this.CheckSearchFilled())
                this.downloadReportBtnLabel = i18n.t('NET20.DOWNLOAD_ALL_RECORDS_FILTERED_SEARCH') as string;
            else
                this.downloadReportBtnLabel = i18n.t('NET20.DOWNLOAD_ALL_RECORDS') as string;

            if(this.allSelectedBackend) {
                results.data.listPage.forEach(element => {
                    this.selectedCustomersIds.push(element.id);
                });
            }
                
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }

    async downloadExcelReport() {
        this.searchFilters = {
                                FreeText: this.freeText,
                                CustomerId: this.advCustomerId,
                                NumericIdsList: this.advNumericId,
                                WorkshopName: this.advWorkshopName,
                                VatNumber: this.advVatNumber,
                                IdSalesman: this.advIdSalesman,
                                TypeOfProposal: this.advTypeOfProposal,
                                IdCountry: this.advCustomerCountry,
                                IdStepContract: this.advIdStepContract,
                                ContractYear: this.advContractYear,
                                IdDistributor: this.advDistributor,
                                ContractExpired: this.advContractExpired,
                                CurrentPage: this.page
                            };
       this.$bvModal.show('download-file-background');                
    }

    openDocsModal(){
        this.$bvModal.show('document-attachments-modal');
    }

    openSalesmanUpdateModal(idCustomer: string){
        let confirmMsg: string = '';
        if(!!idCustomer){
            confirmMsg = i18n.t('NET20.CHG_SALESMAN_SINGLE_CUSTOMER_CONFIRM_MSG') as string;
            confirmMsg = confirmMsg.replace('{0}', this.numericIdSelected.toString());

            General.confirm(confirmMsg, this, ()=> {
                this.selectedCustomer = idCustomer;
                this.totalCustomerInvolved = 1;
                this.$bvModal.show('contractSalesmanUpdate');
            });
        } else {               
            confirmMsg = i18n.t('NET20.CHG_SALESMAN_MULTIPLE_CUSTOMER_CONFIRM_MSG') as string;
            confirmMsg = confirmMsg.replace('{0}', this.totalCustomerInvolved.toString());
            
            General.confirm(confirmMsg, this, ()=> {
                    let CurrentSearch: CustomerGarageFilterModel = {
                                            freeText: this.freeText,
                                            customerId: this.advCustomerId,
                                            numericIdsList: this.advNumericId,
                                            workshopName: this.advWorkshopName,
                                            vatNumber: this.advVatNumber,
                                            idSalesman: this.advIdSalesman,
                                            typeOfProposal: this.advTypeOfProposal,
                                            idCountry: this.advCustomerCountry,
                                            idStepContract: this.advIdStepContract,
                                            contractYear: this.advContractYear,
                                            idDistributor: this.advDistributor,
                                            contractExpired: this.advContractExpired,
                                            currentPage: this.page,
                                        };
                    this.massiveCustomerUpdate = {
                        selectedCustomerId: this.selectedCustomersIds,
                        selectAll: this.allSelectedBackend,
                        deselectedCustomerId: this.unSelectedCustomersId,
                        currentSearch: CurrentSearch
                    }
                    this.$bvModal.show('contractSalesmanUpdate');
            });
        }
    }

    toggleAll(checked) {
        this.allSelectedBackend = checked;
        this.selectedCustomersIds = checked ? this.resultsItems.resultPage.map((r)=> r.id) : []
        this.totalCustomerInvolved = checked ? this.resultsItems.total : 0;

        if(this.unSelectedCustomersId.length > 0)
            this.unSelectedCustomersId = new Array<string>();
    }

    singleToggle(idCustomer: string) {
        if(this.selectedCustomersIds.findIndex(x => x === idCustomer) >= 0) {
            if(this.allSelectedBackend && this.unSelectedCustomersId.length > 0)
                this.unSelectedCustomersId.splice(this.unSelectedCustomersId.findIndex(x => x === idCustomer), 1);

        } else {
            if(this.allSelectedBackend)
                this.unSelectedCustomersId.push(idCustomer);
        }

        if(this.allSelectedBackend) {
            if(this.unSelectedCustomersId.length == 0) {
                this.allSelected = true;
                this.totalCustomerInvolved = this.resultsItems.total;
            } else {
                this.allSelected = false;
                this.totalCustomerInvolved = this.resultsItems.total - this.unSelectedCustomersId.length;
            }
        } else {
            this.totalCustomerInvolved = this.selectedCustomersIds.length;
        }
    }

    resetSelection(){
        this.allSelected = false;
        this.allSelectedBackend = false;
        this.selectedCustomersIds = new Array<string>();
        this.unSelectedCustomersId = new Array<string>();
    }
}
